import { useEffect, useState } from "react";
import AxiosInstance from "./AxiosInstance.js";
import useAPIList, { useAPIListLanguage } from "./useAPIList.js";


export function useSpecialties(showAll=false) {
    return useAPIList(`/api/specialties?showAll=${showAll}`);
}

export function useSpecialtiesLanguage(showAll=false) {
    return useAPIListLanguage(`/api/specialties?showAll=${showAll}`);
}

export function useAllSpecialties() {
    const [specialties, setSpecialties] = useState([]);
  
    useEffect(() => {
        fetchAllSpecialties().then(specialties => setSpecialties(Object.values(specialties).flat())).catch(console.error)
    }, []);
  
    return specialties;
  }


export function fetchAllSpecialties() {
    return AxiosInstance.get(`/api/specialties?showAll=true`).then((res) => {
      return res.data;
    });
  }

// --- Themes
export function fetchThemes(specialtyId) {
    return AxiosInstance.get(`/api/specialties/${specialtyId}/themes`).then(res => res.data)
}

export function addTheme(specialtyId, body) {
    return AxiosInstance.post(`/api/specialties/${specialtyId}/themes`, body).then(res => res.data)
}

export function fetchTheme(id) {
    return AxiosInstance.get(`/api/specialties/themes/${id}`).then(res => res.data)
}

export function updateTheme(id, body) {
    return AxiosInstance.put(`/api/specialties/themes/${id}`, body).then(res => res.data)
}

export function deleteTheme(id) {
    return AxiosInstance.delete(`/api/specialties/themes/${id}`).then(res => res.data)
}

export function fetchSpecialtiesByTargetAudienceId(id) {
  return AxiosInstance.get(`/api/specialties/target-audience/${id}`).then(res => res.data)
}